/**
 * ProfilePasswordReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ProfilePasswordReq
 */
export interface ProfilePasswordReq {
  /** 旧密码 */
  old_password: string
  /** 新密码 */
  new_password: string
}

/**
 * ProfilePasswordReq Schema
 */
export const ProfilePasswordReqSchema: SchemaDefinition = {
  properties: {
    old_password: {
      description: '旧密码',
      format: 'string',
      maxLength: 32,
      minLength: 6,
      type: 'string',
      label: '旧密码',
    },
    new_password: {
      description: '新密码',
      format: 'string',
      maxLength: 32,
      minLength: 6,
      type: 'string',
      label: '新密码',
    },
  },
  required: ['old_password', 'new_password'],
  type: 'object',
}
